<div class="flex flex-col gap-4 px-[8px]">
  <div class="mt-4 -mb-1 flex items-center justify-between">
    <h1 class="textTabsColor text-[24px] font-[700]" i18n="@@regionsListTitle">المناطق</h1>

    <button
      (click)="navigateToAdd()"
      class="add-button flex items-center justify-center gap-2">
      <app-add-icon />
      <span i18n="@@regionsListAddBtn">اضافة منطقة</span>
    </button>
  </div>

  <app-regions-list-filter
    [filters]="filters()"
    (applyFilters)="onApplyFilters($event)"
    (resetFilters)="onResetFilters()" />

  @if (loading()) {
    <div class="borderDivColor mt-2 flex items-center justify-center rounded-[8px] border bg-white py-12 shadow-sm">
      <app-loading />
    </div>
  } @else if (errorMsg()) {
    <div class="borderDivColor mt-2 flex items-center justify-center rounded-[8px] border bg-white py-12 shadow-sm">
      <app-error-data [title]="errorMsg()!" [showRetry]="true" (retry)="loadRegions()" />
    </div>
  } @else {
    <app-tables
      [headerItems]="tableHeaders()"
      [rows]="regionsData()"
      [currentActions]="tableActions()"
      [isFiltersApplied]="isFiltersApplied()"
      [emptyFilterTitle]="
        isArabic() ? 'لا توجد نتائج تطابق الفلاتر المحددة' : 'No regions match your selected filters.'
      "
      [emptyContentTitle]="isArabic() ? 'لم يتم العثور على مناطق' : 'No regions found.'"
      (actionTrigger)="onActionTriggered($event)" />
  }

  @if (totalItems() > 0) {
    <app-pagination
      [itemsPerPage]="filters().pageSize"
      [currentPage]="currentPage()"
      [getPageNumbers]="getPageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="previousPage()"
      (nextPage)="nextPage()"
      (goToPage)="goToPage($event)"
      (changePageNumber)="onPageSizeChange($event)" />
  }

  @if (showSuccessMessage()) {
    <app-successful-notification
      type="success"
      [title]="isArabic() ? 'تم حذف المنطقة بنجاح' : 'Region deleted successfully'" />
  }

  @if (isDeleteDialogOpen()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="
        isInUseError()
          ? isArabic()
            ? 'لا يمكن حذف المنطقة'
            : 'Cannot Delete Region'
          : isArabic()
            ? 'حذف المنطقة'
            : 'Delete Region'
      "
      [description]="
        isInUseError()
          ? isArabic()
            ? 'لا يمكن حذف هذه المنطقة لأنها مرتبطة حالياً بصيدلية أو خط سير أو أكثر.'
            : 'This region cannot be deleted because it is currently assigned to one or more pharmacies or routes.'
          : isArabic()
            ? 'هل أنت متأكد أنك تريد حذف هذه المنطقة؟ لا يمكن التراجع عن هذا الإجراء.'
            : 'Are you sure you want to delete this region? This action cannot be undone.'
      "
      [itemName]="isArabic() ? itemToDelete()?.titleAr : itemToDelete()?.titleEn"
      [confirmContent]="
        deleteLoading()
          ? isArabic()
            ? 'تحميل...'
            : 'Loading...'
          : isInUseError()
            ? isArabic()
              ? 'إغلاق'
              : 'Close'
            : isArabic()
              ? 'حذف'
              : 'Delete'
      "
      [cancelContent]="isInUseError() ? '' : isArabic() ? 'إلغاء' : 'Cancel'"
      [isLoading]="false"
      [error]="deleteError()"
      [showCloseButton]="true"
      (onCancel)="closeDeleteDialog()"
      (onSubmit)="onDeleteDialogSubmit()" />
  }
</div>
